import * as React from "react"
import Svg, { Rect, Path } from "react-native-svg"

function CameraIcon(props) {
    return (
        <Svg
            xmlns="http://www.w3.org/2000/svg"
            width={72}
            height={72}
            viewBox="0 0 72 72"
            fill="none"
            {...props}
        >
            <Rect
                x={1}
                y={1}
                width={70}
                height={70}
                rx={35}
                stroke="#fff"
                strokeWidth={2}
            />
            <Rect x={4} y={4} width={64} height={64} rx={32} fill="#fff" />
            <Path
                d="M46 27h-3.465l-1.704-2.555A.999.999 0 0040 24h-8a1 1 0 00-.831.445L29.464 27H26a3 3 0 00-3 3v14a3 3 0 003 3h20a3 3 0 003-3V30a3 3 0 00-3-3zm-5.5 9.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z"
                fill="#000"
            />
        </Svg>
    )
}

export default CameraIcon
